module.exports = __webpack_public_path__ + "static/img/包裝第五組組長-陳維新.3f11e3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/包裝第五組組長-陳維新.jpg
// module id = EEyz
// module chunks = 1